import { Component, HostListener, afterNextRender, inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.scss',
})
export class CookieBannerComponent {
  private static readonly STORAGE_KEY = 'cookieConsent';
  private readonly platformId = inject(PLATFORM_ID);

  // Start hidden to avoid rendering during SSR/prerendering
  readonly visible = signal(false);

  constructor() {
    // Only evaluate localStorage after hydration is complete on the client
    afterNextRender(() => {
      this.visible.set(!CookieBannerComponent.isAccepted());
    });
  }

  accept(): void {
    try {
      localStorage.setItem(CookieBannerComponent.STORAGE_KEY, 'accepted');
    } catch {
      // ignore storage errors
    }
    this.visible.set(false);
  }

  private static isAccepted(): boolean {
    try {
      return localStorage.getItem(CookieBannerComponent.STORAGE_KEY) === 'accepted';
    } catch {
      return false;
    }
  }

  @HostListener('window:storage')
  onStorageChange(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.visible.set(!CookieBannerComponent.isAccepted());
    }
  }
}
